import styled, { css } from "styled-components";
import { media } from "../../../../layouts/utils";
import { colorBrandPrimary } from "src/global.style";

export const Container = styled.div`
  padding: 40px 130px;
  position: relative;

  @media (max-width: 767px) {
    padding: 20px 50px;
  }
`;

export const Title = styled.div`
  color: #000;
  font-family: "Platform Web";
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;

  @media (max-width: 767px) {
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 35px;
  }
`;

export const Content = styled.div`
  display: flex;
`;

export const MainImage = styled.div`
  position: relative;
  flex: 1;

  div {
    position: absolute;
    top: -20px;

    div {
      position: absolute;
      width: 342px;
      height: 350px;
      background: ${colorBrandPrimary.verdeTaverna};
      border-radius: 11px;
    }

    img {
      position: absolute;
      top: -20px;
      left: -100px;
    }
  }

  @media (max-width: 1142px) {
    display: none;
  }
`;

export const Sorriso = styled.div`
  width: 100%;
  height: 30px;
  background-image: ${(props) =>
    props.dark
      ? `url("/tagnext/assets/img-simplifique2.png")`
      : `url("/tagnext/assets/img-simplifique.png")`};
  background-repeat: no-repeat;
  background-position-x: center;
  margin-bottom: 20px;
`;

export const Plans = styled.div`
  flex: 2;
`;

export const Modal = styled.div`
  position: absolute;
  bottom: 23.25rem;
  left: 0;
  right: 0;
  margin: auto;

  max-width: 37.5rem;
  width: 100%;
  // background-color: rgb(0, 28, 85);
  background: transparent
    linear-gradient(90deg, #ee3b66 0%, #f84872 32%, #ff045e 85%, #ff045e 100%)
    0% 0% no-repeat padding-box;
  padding: 1.5rem 1.7rem;
  border-radius: 1rem;

  color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  z-index: 3;
  display: ${({ open }) => (open ? "flex" : "none")};

  @media (max-width: 768px) {
    width: 90%;
  }

  .inputCelular {
    width: 100%;
    height: 3.75rem;
    background: white;
    padding: 1rem;
    border: 1px solid #ffffff;
    border-radius: 10px 10px 5px 5px;
    opacity: 1;
  }

  ${media.phone`
		z-index:3;
		
		.botaoConfirmar {
			min-width: 100%;
			background-color: white;
			color: #F84872;
		}

	`}
`;
export const ModalTitle = styled.div`
  font-size: 2rem;
  font-family: "Platform Web";
  color: #ffffff;
  width: 100%;
  ${media.phone`
		font-size: 1.5rem;
		text-align: center;
	`}
`;
export const ModalDescription = styled.div`
  width: 100%;
  font-size: 1rem;
`;
export const ModalInput = styled.input`
  width: 100%;
  height: 3.75rem;
  background: white;
  padding: 1rem;
  border: 1px solid #ffffff;
  border-radius: 10px 10px 5px 5px;
  opacity: 1;
`;

const buttonEnabled = css`
  cursor: pointer;
  // color: rgb(36, 32, 107);
  &:hover {
    transition: 0.2s;
    transform: translateY(-0.25rem);
    width: 140px;

    ${media.phone`
			min-width: 100%;
		`}
  }
  ${media.phone`
		min-width: 100%;
	`}
`;

const buttonDisabled = css`
  cursor: not-allowed;
  background: ${({ color }) => color};
  color: ${({ textColor }) => textColor};
  opacity: 0.6;
  ${media.phone`
		min-width: 100%;
	`}
`;

export const Button = styled.div`
  display: flex;
  padding: 17px 32px;
  justify-content: center;
  align-items: center;

  font-family: "Work Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: 1px solid transparent;
  color: ${({ color }) => color};
  border-radius: 100px;
  background: ${({ background }) => background};
  transition: all 0.5s;
  ${({ disabled }) =>
    disabled &&
    `
		opacity: 0.5;
	`}

  &:hover {
    border-color: #fff;
    color: #fff;
    background: #0e1e64;
  }
`;
export const ErrorText = styled.div`
  width: 100%;
  font: normal normal normal 16px/22px "Work Sans";
  text-align: center;
  display: flex;
  justify-content: flex-end;
  ${media.phone`
	display: none;
	`}
`;
export const ErrorTextMobile = styled.div`
  width: 100%;
  font: normal normal normal 16px/22px "Work Sans";
  text-align: center;
  display: none;
  ${media.phone`
		display: flex;
	`}
`;
export const LoadingCupom = styled.img`
  width: 2rem;
`;
